module.exports = __webpack_public_path__ + "static/media/cam5_f.5cccad80.webp";